import { format, isValid, isAfter, isBefore, parse, parseISO } from 'date-fns'
import { MaybeString } from './types/types'

export const BASIC_DATE_FORMAT = 'dd.MM.yyyy'

// eslint-disable-next-line quotes
export const ISO_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss"

// eslint-disable-next-line quotes
export const ISO_DATE_MIDNIGHT_FORMAT = "yyyy-MM-dd'T'00:00:00"

const formatNewDate = (dateFormat: string, dateStr?: MaybeString): string => {
  const date = dateStr ? new Date(dateStr) : new Date()
  return format(date, dateFormat)
}

export const formatDate = (dateStr: string, dateFormat: string) => {
  return formatNewDate(dateFormat, dateStr)
}

export const formatDateOrNull = (
  dateStr: MaybeString,
  dateFormat: string
): MaybeString => (dateStr != null ? formatDate(dateStr, dateFormat) : dateStr)

export const formatBasicDateStr = (dateStr: MaybeString): MaybeString => {
  return formatDateOrNull(dateStr, BASIC_DATE_FORMAT)
}

export const formatBasicDate = (date: Date) => {
  return format(date, BASIC_DATE_FORMAT)
}

export const formatISODateMidnight = (date: Date) => {
  return format(date, ISO_DATE_MIDNIGHT_FORMAT)
}

export const isDateValid = (date: Date | null) => {
  return date !== null && isValid(date)
}

export const parseISODate = (dateValue: MaybeString) => {
  const parsedDate = dateValue ? parseISO(dateValue) : null
  return isDateValid(parsedDate) ? parsedDate : null
}

export const getNowAsStr = () => Date.now().toString()

export const isAfterCurrentDate = (dateStr: string) => {
  const parsedDate = parse(dateStr, ISO_DATE_FORMAT, new Date())
  return parsedDate.valueOf() > Date.now().valueOf()
}

export const isBeforeDate = (date: Date, dateStr?: string) =>
  dateStr ? isBefore(new Date(dateStr), date) : false

export const isAfterDate = (date: Date, dateStr?: string) =>
  dateStr ? isAfter(date, new Date(dateStr)) : false

export const createNewBasicDateStr = () => formatNewDate(BASIC_DATE_FORMAT)

export const createNewISODateStr = () => formatNewDate(ISO_DATE_FORMAT)

export const convertISODateStrToBasicDateStr = (dateStr: string) => {
  return formatBasicDate(parseISO(dateStr))
}
